import classnames from 'classnames'

import { If, DsIcon } from '@itau-loans-www/components'

import { useCircularProgressLoader, CircularProgressLoader } from './components/CircularProgressLoader'

import './final-loader.scss'

const FinalLoader = () => {
  
  const { progress, isEnded } = useCircularProgressLoader()

  const classNames = classnames('final-loader', {
    '--ended': isEnded
  })

  const title1 = classnames('final-loader__title-text', {
    '--active': progress > 0 && progress < 50
  })

  const title2 = classnames('final-loader__title-text', {
    '--active': progress > 50 && progress < 99
  })

  const title3 = classnames('final-loader__title-text', {
    '--active': progress > 99
  })

  return (
    <div className={classNames}>
      <div className="final-loader__container">
        <div className="final-loader__title">
          <p className={title1}>
            Aguarde, estamos analisando suas informações
          </p>
          <p className={title2}>
            Estamos confirmando seus dados
          </p>
          <p className={title3}>
            tudo certo!
          </p>
        </div>
        <CircularProgressLoader progress={progress}>
          <If
            condition={isEnded}
            renderIf={<DsIcon name="ids-check" isLocal={true} />}
            renderElse={<DsIcon name="ids-user" isLocal={true} />}
          />
        </CircularProgressLoader>
      </div>
    </div>
  )
}

export default FinalLoader